import React from 'react'
import Image from "next/image";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import styles from "./tnpsc-admissions.module.css";
import Link from 'next/link';
import dynamic from "next/dynamic";
const Acheiver = dynamic(()=>import("../../components/tnpsc-acheiver/achiver"));
import Icon from "../../assets/images/Tnpsc/2000-Achiver.png";
import Emioption from "../../components/Service/emioption";


  const feestructure3 =[
      {cont1:"Anna Nagar",
        cont:"Regular(Hybrid)",    
        date: "25.03.2026",
       cont2:"05:30 pm to 08:00 pm",
         fee:"₹45,000",  
        pay:(<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.paybutton} btn btn-danger`}>
                  Pay Now
                </button>
                </a>) },

       {cont1:"Adyar",
         cont:"Regular(Hybrid)", 
         date: "18.03.2026", 
        cont2:"10:30 am to 01:30 pm", 
          fee:"₹45,000", 
          pay:(<a href="https://admissionsv1.shankariasacademy.com/?center=Adyar&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.paybutton} btn btn-danger`}>
                  Pay Now
                </button>
                </a>) },

        {cont1:"Coimbatore",
          cont:"Regular(Offline)", 
          date: "27.04.2026",
         cont2:"10.00 am to 01.00 pm", 
           fee:"₹32,000", 
           pay:(<a href="https://admissionsv1.shankariasacademy.com/?center=COVAI&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.paybutton} btn btn-danger`}>
                  Pay Now
                </button>
                </a>) },

       {cont1:"Salem",
         cont:"Regular(Offline)",  
         date: "30.04.2026",  
        cont2:"02:00 pm to 05:00 pm", 
          fee:"₹32,000", 
          pay:(<a href="https://admissionsv1.shankariasacademy.com/?center=Salem&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.paybutton} btn btn-danger`}>
                  Pay Now
                </button>
                </a>) },

        {cont1:"Trichy",
          cont:"Regular(Offline)",  
          date: "30.03.2026",
         cont2:"02:00 pm to 05:00 pm", 
           fee:"₹32,000", 
           pay:(<a href="https://admissionsv1.shankariasacademy.com/?center=Trichy&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.paybutton} btn btn-danger`}>
                  Pay Now
                </button>
                </a>) },


        {cont1:"Madurai",
          cont:"Regular(Offline)", 
          date: "30.03.2026",
         cont2:"02:00 pm to 05:00 pm", 
           fee:"₹32,000", 
           pay:(<a href="https://admissionsv1.shankariasacademy.com/?center=Madurai&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.paybutton} btn btn-danger`}>
                  Pay Now
                </button>
                </a>) }, 
                    
        {cont1:"Coimbatore",
          cont:"Regular(Offline)", 
          date: "19.03.2026",
         cont2:"10.00 am to 01.00 pm", 
           fee:"₹32,000", 
           pay:(<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.paybutton} btn btn-danger`}>
                  Pay Now
                </button>
              </a>) },

         {cont1:"Thiruvarur",
          cont:"Regular(Offline)", 
          date: "16.03.2026",
         cont2:"10.00 am to 01.00 pm", 
           fee:"₹30,000", 
           pay:(<a href="https://admissionsv1.shankariasacademy.com/?center=Thiruvarur&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                        <button className={`${styles.paybutton} btn btn-danger`}>
                          Pay Now
                        </button>
                    </a>) },

        {cont1:"Namakkal",
          cont:"Regular(Offline)", 
          date: "24.04.2026",
         cont2:"10.00 am to 01.00 pm", 
           fee:"₹29,000", 
           pay:(<a href="https://admissionsv1.shankariasacademy.com/?center=Namakkal&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.paybutton} btn btn-danger`}>
                  Pay Now
                </button>
                    </a>) },    
     
    ]

    const features = [
        "More than 150 classes of 150 minutes each for Prelims",
        "25 Preliminary Tests – Online with video solutions",
        "Highly experienced TNPSC faculty members",
        "Bilingual classroom instruction",
        "Student–Achiever interaction with Group I officers",
        "Scheduled mentoring by experts & service candidates",
        "Concept sheets for all key subjects",
        "Strong focus on Current Affairs & TNPSC trends",
        "Disciplined and adaptive learning approach"
    ];


   
   const acheiver=()=>{
   
      useEffect(() => {
      AOS.init({
        duration: 800,
        easing: "ease-in-out",
        once: true,
        offset: 100,
      });
    }, []);

   }

const About_TNPSC = () => {
 
    const prelimslist1 =[
        {cont:"Exhaustive coaching - ",cont1:"More than 150 classes of 150 minutes each for Prelims."},
        {cont:"Extensive Class Test - ",cont1:"25 Preliminary Test - Online Test with video solution."},
        {cont:"Highly Qualified and Experienced Trainers - ",cont1:"Faculty members who have vast experience in TNPSC Examinations."},
        {cont:"Class Instruction - ",cont1:"Bilingual Mode Only"},
        {cont:"Student- Achiever Interactions - ",cont1:"Regular interaction of students with succesful working Group I officers. "},
        {cont:"Mentoring Programme - ",cont1:"Scheduled Mentoring Programme by expert faculty and service candidates. Continuous evaluation of students and provision of mentoring to students who are lacking in subjects. "},
        {cont1:"Provision of Concept Sheets for the required subjects. "},
        {cont1:"Focuses on Current Affairs, Articles,etc based on the dynamics of TNPSC examination."},
        {cont1:"Disciplined and adoptable approach."}  
      ]

    const prelimslist2 =[
        {cont1:"The course is exclusively designed and integrated for the Tnpsc Group I Preliminary and Main Examination -2026."},
        {cont1:"A Single-window approach for Multiple TNPSC preliminary Exams 2026 (Group I, II, IIA & IV Exams) "},
        {cont1:"Systematic syllabus coverage by an experienced team of faculty members."},
        {cont1:" Language (English or Tamil) Coverage for Group-II, IIA, and IV Preliminary Exams 2026"},
        {cont1:"12 + month duration, 6 days of classes per week, Tests on Weekends and to Complete the Syllabus. Extra classes will be conducted, if required."},
        {cont1:"230 + No. of GS Classes & 30 +Preliminary Test with Discussion by Respective Subject Faculties & 15 Main Tests For Group I-Exam."},
        {cont1:"Total No. of Groups I and II & II A Preliminary Online Practice Test: 75 Nos. "},
        {cont1:"To get subject revision, recorded class videos will be available for up to 30 days."},
        {cont1:"Groups II and II A -The main syllabus will not be covered in this course. "},
        {cont1:"Updated Study Materials as per Tnpsc syllabus. "},
    ]

  return (
    <>

    <section id="courseandfees">
        <div className="container py-5" id="gspcm">
          <h2 className={`text-center mb-5 ${styles.mainTitle}`}>Course & Fee Structure – 2026</h2>
          <div className="row g-4">

            <div data-aos="fade-down" className="col-xl-6 col-lg-6 col-12"> 
                <div className= 'h-100'>
                   <span className={styles.achiverbadge}>Our achievements</span>
                     <div className='pt-3'>
                        <span className=""><Image src={Icon} width="336" height="236" alt="New_icon" className="img-fluid mx-2" /></span>
                         <p className="pt-3">TNPSC candidates selected for Group I, II & IV services from our academy.</p>
                    </div>

                    <Acheiver />

                    <div className={styles.featureSection}>
                        {features.map((item, index) => (
                            <div key={index} className={styles.featureCard}>
                                <span className={styles.icon}>✓</span>
                                <p>{item}</p>
                            </div>
                        ))}
                    </div>
                </div> 
            </div>
            
            <div data-aos="fade-down" className="col-xl-6  col-lg-6 col-12">
                 <div  className={`${styles.premiumCard} ${styles.highlightCard} h-100`}>
                <div className={styles.cardTop}>
                  <div className={styles.ribbon}>Admission Opening</div>
                  <h4 className='pb-2'>TNPSC Group I & II Preliminary</h4>
                </div>

                {/* <div className={styles.priceBox}>
                  ₹34,000
                </div> */}
                {/* <button className={styles.primaryBtn}>Pay Now</button> */}
                <div className={styles.scheduleSection}>
                    {feestructure3.map((item, index) => (
                    <div key={index} className={styles.scheduleItem}>

                        {/* CENTER + MODE */}
                        <div className={styles.colCenter}>
                            <div className={styles.mainText}>{item.cont1}</div>
                            <div className={styles.subText}>{item.cont}</div>
                        </div>

                        {/* DATE */}
                        <div className={styles.colDate}>
                            <div className={styles.mainText}>{item.date}</div>
                             <div className={styles.subText}>{item.cont2}</div>
                        </div>

                        {/* FEE */}
                        <div className={styles.colFee}>
                            {item.fee}
                        </div>

                        <div className={styles.admission}>
                            {item.pay}
                        </div>

                     </div>
                    ))}
                </div>
              </div>
            </div>

            <div data-aos="zoom-in" className={styles.premiumCard}>
              <div className={`${styles.facultyborder3} row h-100 `}>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                  <p className={`${styles.sectionsubtitle} mb-0`}>TNPSC Group I & II Preliminary  </p>
                  <p className={`${styles.sectionsubtitle} pb-0`}>Total Amount</p>
                </div>

                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                  <span className={`${styles.acheiverrank}`}> <span className={`${styles.sectionredtitle} `}><b>₹</b>45,000*</span><span>(Anna Nagar)</span></span>
                </div>

                <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right">
                  <Emioption />                
                </div>

                <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right pt-xl-0 pt-3">
                  <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Here</button></a>
                </div>

                <p className={`${styles.aboutparagraph1}  p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;Fees are inclusive of GST & SIA study materials.</p>
              </div>
            </div>

            <div className="row">
              <div  className="col-md-12 col-lg-8 col-xl-8 col-12 pt-3 pe-xl-0">
                {/* <p className={`${styles.aboutparagraph1} p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;<b>₹5,000</b> Discount will be applicable for Integrated Course payment <b>(GS + CSAT + Optional)</b></p> */}
              </div>
              <div className="col-md-12 col-lg-6 col-xl-4 col-12 pt-3 ps-xl-0">
              </div>
            </div>
          </div>
        </div>
    </section>



{/* <section id="coursedetails">
    <div className="container pt-lg-1">
        <div className="row" id="gspcm" style={{paddingTop: "90px"}}>
           <div className="col-lg-6 col-md-12">
               <div className="row">
                    <div className='col'>  
                        <div className='row pt-3'>
                            <h3 className={`${styles.pagegspcm}`}>TNPSC Gr I Preliminary & Mains (PCM) </h3> 
                            <table className="table">
                            <tbody>
                                <tr>
                                    <td className={`${styles.tableheading}`}>Anna Nagar<br/><span className={`${styles.tablepara}`}>Regular(Hybrid)</span></td>
                                    <td className={`${styles.tablepara}`}>29.08.2025 <br/><p className={`${styles.tablepara}`}>10:30 am to 01:30 pm </p></td>
                                    <td className={`${styles.tablepara} `}>₹95,000</td>
                                    <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                </tr>

                                 <tr>
                                    <td className={`${styles.tableheading}`}>Anna Nagar<br/><span className={`${styles.tablepara}`}>Regular(Hybrid)</span></td>
                                    <td className={`${styles.tablepara}`}>21.07.2025 <br/><p className={`${styles.tablepara}`}>02:00 pm to 05:00 pm </p></td>
                                    <td className={`${styles.tablepara} `}>₹95,000</td>
                                    <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                </tr>


                                <tr>
                                    <td className={`${styles.tableheading}`}>Anna Nagar<br/><span className={`${styles.tablepara}`}>Regular(Hybrid)</span></td>
                                    <td className={`${styles.tablepara}`}>23.06.2025 <br/><p className={`${styles.tablepara}`}>10:30 am to 01:30 pm </p></td>
                                    <td className={`${styles.tablepara} `}>₹95,000</td>
                                    <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                </tr>

                               
                            </tbody>
                            </table>
                        </div>

                        <div className="row pt-2">
                            <div className="col">
                                 <h3 className={`${styles.highlightbtn}`}>TNPSC PCM  2025-2026 - Integrated Foundation Course - Highlights:</h3>
                            <ul className={`${styles.ulclass1} ps-1 pt-2 mb-0`}>
                                {prelimslist2.map((item,index)=>(
                                <li className={`${styles.ulliclass1} ${styles.siaacheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan1} d-inline`}>
                                        <span className={`${styles.acheiverrank}`}> {item.cont1}</span>
                                        </p>
                                    </div>
                                </li>
                                ))}
                            </ul>
                            </div>
                        </div> 
                                   
                    </div>  
               </div>
          
                <div className="col-xl-6 pt-5">
                   <button className={`${styles.normalbluebutton}`} type="submit">Our achievements</button>
                </div>

                <div className="col-xl-6 pt-3 pt-lg-5">
                    <h3 className={`${styles.pagemaintitles}`}>TNPSC toppers</h3> 
                </div>

                <div className="row pt-3">
                    <div className='col-md-6'>
                      <Image src={Icon} className="img-fluid w-100" alt="Tnpsc Icon" title="Tnpsc Icon"/>
                    </div>
                </div>

                            <div className='row' id="topperlist">
                                <div className='col'>
                                    <p className={`${styles.titles} pt-3 mb-5`}>TNPSC candidates selected for Group I, II & IV services from our academy.</p>
                                </div>
                            </div>
                    
                            <div className="row">
                                <div className='col'>
                                    <div className='row pt-3'>
                                       <div className="col-md-4 text-center">
                                         <div className={`${ styles.toppersupsc}`}> 
                                            <div>
                                                <Image src={KATHIRSELVI} className="img-fluid" alt="Tnpsc_toppers" title="Tnpsc_toppers" />
                                            </div>
                                            <span1></span1> 
                                                <p className={`${styles.acheivername} text-center mb-0`}>KATHIRSELVI K</p>
                                                <p className={`${styles.acheiverrank}  text-center mb-0`}>State Rank - 1 (2024)</p>
                                                <p className={`${styles.acheiverrank1}  text-center mb-0`}>Interview Program</p>
                                          </div>
                                        </div>
                                    <div className="col-md-4 text-center">
                                    <div className={`${ styles.toppersupsc}`}>
                                       <div>
                                        <Image src={HARIPRIYANKKA} className="img-fluid" alt="Tnpsc_toppers" title="Tnpsc_toppers" />
                                       </div>
                                       <span1></span1>
                                        <p className={`${styles.acheivername} text-center mb-0`}>HARI PRIYANKKA N</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>State Rank - 2 (2024)</p>
                                        <p className={`${styles.acheiverrank1}  text-center mb-0`}>Test Series & Interview Program</p>
                                        
                                    </div>
                                    </div>
                                    <div className="col-md-4 text-center">
                                    <div className={`${ styles.toppersupsc}`}>
                                        <div>
                                          <Image src={KERANAPUK} className="img-fluid" alt="Tnpsc_toppers" title="Tnpsc_toppers" />
                                        </div>
                                        <span1></span1>
                                        <p className={`${styles.acheivername} text-center mb-0`}>KERANAPUK LYTHIA P</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>State Rank - 4 (2024)</p>
                                        <p className={`${styles.acheiverrank1}  text-center mb-0`}>Interview Program</p>
                                    </div>
                                    </div>
                                    </div>
                                    <br/>
                                    <Link href={"/our-achievers"} className={`${styles.morelink}`}>& More...</Link>
                                </div>  
                            </div>
                            
                            {/* <div className="row pt-2">
                            <div className="col">
                            <ul className={`${styles.ulclass1} ps-1 pt-2 mb-0`}>
                                {prelimslist2.map((item,index)=>(
                                <li className={`${styles.ulliclass1} ${styles.siaacheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan1} d-inline`}>
                                        <span className={`${styles.acheiverrank}`}> {item.cont1}</span>
                                        </p>
                                    </div>
                                </li>
                                ))}
                            </ul>
                            </div>
                        </div> 

           </div>
                    
            <div className="col-lg-6 col-md-12">

            <div className="col-12 col-lg-12 pt-4">
                <Emioption />
            </div>

            <div className="container">
                <div className="row pt-3">

                            <div className="col">
                                <p className={`${styles.aboutparagraph1} p-2`}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; <span>(Class Instruction - Bilingual Mode Only)</span></p>                        </div>
                        </div>
            </div>

            <div className="row">
                <div className="col">
                <ul className={`${styles.ulclass1} ps-1 pt-2 mb-0`}>
                    {prelimslist1.map((item,index)=>(
                    <li className={`${styles.ulliclass1} ${styles.siaacheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                        <div className="d-inline">
                            <p className={`${styles.ullispan1} d-inline`}>
                            <span className={`${styles.acheivernames} `}>{item.cont} &nbsp;</span><span className={`${styles.acheiverranks}`}> {item.cont1}</span>
                            </p>
                        </div>
                    </li>
                ))}
            </ul>
            </div>
            </div>

            </div>
        </div>
        <hr></hr>
    </div>
</section> */}
    </>
  )
}
export default About_TNPSC;